// Marcadores amarelos do design aplicados às listas do HTML que o backend entrega (CAT-L01).
const ESTILO_DAS_REGRAS = [
  'text-[12px] leading-[1.6] text-content',
  '[&_p]:m-0 [&_p+p]:mt-2.5 [&_p+ul]:mt-2.5 [&_ul+p]:mt-2.5',
  '[&_ol]:m-0 [&_ol]:pl-5 [&_ul]:m-0 [&_ul]:flex [&_ul]:list-none [&_ul]:flex-col [&_ul]:gap-2.5 [&_ul]:p-0',
  "[&_ul>li]:relative [&_ul>li]:pl-4 [&_ul>li]:before:absolute [&_ul>li]:before:left-0 [&_ul>li]:before:top-1.5 [&_ul>li]:before:h-[7px] [&_ul>li]:before:w-[7px] [&_ul>li]:before:rounded-full [&_ul>li]:before:bg-brand-yellow [&_ul>li]:before:content-['']",
].join(' ');

/** Regras de uso em sequência, sem carrossel (CAT-10, CAT-36). O HTML vem do motor. */
export default function RegrasDeUso({ paginas }: { paginas: string[] }) {
  return (
    <div className="flex flex-col gap-2.5">
      {paginas.map(pagina => (
        <div key={pagina} className={ESTILO_DAS_REGRAS} dangerouslySetInnerHTML={{ __html: pagina }} />
      ))}
    </div>
  );
}
